import * as HLF from "html-living-framework";
import * as Constants from "Data/Constants";
import { MusicGameLoopButton } from "GameObjects/MusicGame/Buttons/LoopButton";
import * as Topics from "Data/Topics";
import { Application } from "Singletons/Application";
// import AudioPreloadManager, { PRIORITY } from "Singletons/AudioPreloadManager";
import { ProgressBar } from "GameObjects/MusicGame/ProgressBar";
import { MusicManager } from "Singletons/MusicManager";

// enum STATUS {
//     NEVER = -1,
//     EVENTUALLY = 0,
//     LATER = 3,
//     SOON = 5,
//     NEXT = 9,
//     IMMEDIATELY = 10,
// }

export abstract class MusicGameCharacter extends HLF.Input.Receptacle {

    public static instances: { [id: number]: MusicGameCharacter };

    // protected _bg = this._visuals.addChild(HLF.PixiUtils.makeSprite("button-default", Constants.SPRITESHEET_UI));
    protected _debugText = this._visuals.addChild(HLF.PixiUtils.makeText("", Constants.FONT_GEL_MED_35, 35, 0xffffff));
    protected _subscriptions: any[];
    protected _progressBar = this._visuals.addChild(new ProgressBar());
    protected _spine: PIXI.spine.Spine;

    protected abstract animations: {
        idle: string,
        idleToReady: string,
        ready: string,
        playing: string,
    };

    private readonly _data: { id: number, loop: number, name: string };
    private _loadedSongName: string = "";

    constructor(pData: {
        id: number,
        name: string,
        skeleton: string,
    }) {
        super();
        this._data = { loop: Constants.NO_LOOP, ...pData };
        this._debugText.text = pData.name;
        this._spine = this._visuals.addChildAt(HLF.PixiUtils.makeSpine(pData.skeleton), 0);
        this._spine.scale.set(0.21);
        this._spine.interactive = true;
        this.darken = 0.7;
        this._spine.state.addListener({
            complete: this.onAnimComplete.bind(this),
        });

        if (MusicGameCharacter.instances === undefined) {
            MusicGameCharacter.instances = {};
        }
        MusicGameCharacter.instances[this._data.id] = this;
        this._progressBar.position.y = 50;
        // const rect = this._spine.getBounds();
        // console.log(rect);
        // this.hitArea = rect;
        // const g = this.addChildAt(new PIXI.Graphics(), 0);
        // g.beginFill(0xff0000, 0.5);
        // g.drawRect(rect.x, rect.y, rect.width, rect.height);
        // g.endFill();
        this._subscriptions = [
            PubSub.subscribe(Topics.SOLO_QUEUED, this.onMessageReceived.bind(this)),
            PubSub.subscribe(Topics.START_SOLO, this.onMessageReceived.bind(this)),
            PubSub.subscribe(Topics.STOP_SOLO, this.onMessageReceived.bind(this)),
            PubSub.subscribe(Topics.STOP_ALL_SOLOS, this.onMessageReceived.bind(this)),

            PubSub.subscribe(HLF.GAME_PAUSED, this.onPause.bind(this)),
            PubSub.subscribe(HLF.GAME_UNPAUSED, this.onResume.bind(this)),
        ];

        // for (let i = 0; i < 3; i++) {
        //     this.preloadSolo(i, false, PRIORITY.LATER);
        //     this.preloadSolo(i, true, PRIORITY.LATER);
        // }
    }

    public get data() {
        return this._data;
    }

    public get isPlaying() {
        return Application.instance.audio.getAudioTrack(this._loadedSongName, Constants.AUDIO_CATEGORY_SOLO)?.isPlaying() ?? false;
    }

    protected get isPreparing() {
        return this._progressBar.isActive;
    }

    protected set darken(pAmount: number) {
        this._spine.tint = HLF.Colour.lerpHex(0xffffff, 0x160a12, pAmount);
    }

    public update(pDeltaTime: number): void {
        if (this._spine !== undefined) {
            this._spine.update(pDeltaTime);
        }

        this._progressBar.progressValue += pDeltaTime;
    }

    public getTrackTimePos(): number {
        const track = Application.instance.audio.getAudioTrack(this._loadedSongName, Constants.AUDIO_CATEGORY_SOLO);

        if (track !== undefined) {
            return track.getTimePos();
        }
        else {
            return -1;
        }
    }

    public setProgressBarValues(pMin: number, pMax: number) {
        this._progressBar.setMinMaxValues(pMin, pMax);
        this._progressBar.progressPerc = 0;
    }

    public destroy() {
        super.destroy();
        Application.instance.audio.stop(this._loadedSongName, Constants.AUDIO_CATEGORY_SOLO);
        this._subscriptions.forEach(PubSub.unsubscribe);
    }

    protected stopSolo(pData: any) {
        const track = Application.instance.audio.getAudioTrack(this._loadedSongName, Constants.AUDIO_CATEGORY_SOLO);
        if (track?.isPlaying()) {
            track.off(HLF.HowlerUtils.Events.END);
            track.stop();
            console.log("stopped currently playing solo", { 'character': this.data.id, 'loop': this.data.loop });
            PubSub.publishSync(Topics.SOLO_STOPPED, {
                character: this.data.id,
                loop: -1,
            });
        }
        this._data.loop = -1;
        this._progressBar.hide(false);
        this.updateDebugText();
        this.darken = 0.7;
        this.playAnimation(this.animations.idle);
    }

    protected startSolo(pData: { character: number, loop: number, bar: number, time: number }): void {
        const myLoop = this._data.loop;
        const loopToPlay = pData.loop;
        // console.log("Character " + this.data.id + " starting solo " + this.data.loop);
        this._progressBar.hide(true, () => {
            this.updateDebugText();
        });
        // this._noteParticleSystem.startEmitting();
        if (myLoop !== Constants.NO_LOOP && !!this._loadedSongName) {
            const prevTrack = Application.instance.audio.getAudioTrack(this._loadedSongName, Constants.AUDIO_CATEGORY_SOLO);
            prevTrack?.stop();
            console.log("replace solo", this._loadedSongName);
            // PubSub.publishSync(Topics.REQUEST_CANCEL_SOLO, { 'character': this.data.id });
        }
        this._data.loop = pData.loop;
        this._loadedSongName = `solo_${this.data.id}_${this.data.loop}`;
        // AudioPreloadManager.getFilename(
        //     this.data.loop,
        //     this.data.id,
        //     false,
        // );
        console.log("playing %s", this._loadedSongName);
        const track = Application.instance.audio.getAudioTrack(this._loadedSongName, Constants.AUDIO_CATEGORY_SOLO);

        if (track !== undefined) {
            track.setLooped(true);
            track.on(HLF.HowlerUtils.Events.END, () => this.onSoloEnded());
            track.play();
            PubSub.publishSync(Topics.SOLO_STARTED, { 'character': this.data.id, 'loop': this.data.loop });
        }
        this.updateDebugText();
        this.darken = 0;
        this.playAnimation(this.animations.playing);
    }

    /** Called by both drag-and-drop and click-and-click */
    protected addDraggable(pDraggable: HLF.Input.Draggable): void {
        super.addDraggable(pDraggable);
        if (pDraggable instanceof MusicGameLoopButton) {
            this.onLoopButtonActivated(pDraggable);
        }
    }

    /** Handler for user interaction, calls musicmanager via pubsub */
    protected onLoopButtonActivated(pDraggable: MusicGameLoopButton) {
        pDraggable.deselect();
        const myLoop = this._data.loop;
        const loopToPlay = pDraggable.data.id;
        if (loopToPlay === Constants.NO_LOOP) {
            PubSub.publishSync(Topics.REQUEST_CANCEL_SOLO, { 'character': this.data.id, 'loop': loopToPlay });
            console.log("queued solo cancelled " + this._data.name);
            this._progressBar.hide(true, () => {
                this.updateDebugText();
            });
            if (!this.isPlaying) {
                this.playAnimation(this.animations.idle);
            }
        }
        else {
            // console.log("requesting solo", { 'character': this.data.id, 'loop': loopToPlay });
            PubSub.publishSync(Topics.REQUEST_SOLO, { 'character': this.data.id, 'loop': loopToPlay });
            // this._debugText.text = this.data.name + "\n" + "requesting";
            // AudioPreloadManager.UpdatePriority({
            //     culture: this.data.loop,
            //     alternate: true,
            //     priority: PRIORITY.SOON,
            //     character: this.data.id,
            // });
        }
        this.updateDebugText();
    }

    protected onDragBegin(pTopic: string, pDraggable: MusicGameLoopButton): void {
        this._spine.hitArea = this._spine.getLocalBounds();
        super.onDragBegin(pTopic, pDraggable);

        const myLoop = this._data.loop;
        const loopToPlay = pDraggable.data.id;
        if (loopToPlay !== Constants.NO_LOOP || myLoop !== Constants.NO_LOOP) {
            if (loopToPlay === Constants.NO_LOOP) {
                if (this.isPreparing) {
                    this._debugText.text = "Drop Here\nstop playing\ncancel queued";
                }
                else {
                    this._debugText.text = "Drop Here\nstop playing";
                }
            }
            else if (myLoop !== Constants.NO_LOOP) {
                if (myLoop !== loopToPlay) {
                    this._debugText.text = "Drop Here\nchange loops";
                }
                else {
                    this._debugText.text = "Drop Here\nrestart loop";
                }
            }
            else {
                this._debugText.text = "Drop Here\nstart playing";
            }
        }
        else if (this.isPreparing) {
            this._debugText.text = "Drop Here\ncancel queued";
        }
        else {
            this.interactive = false;
        }
    }

    protected onDragEnd(pTopic: string, pDraggable: MusicGameLoopButton): void {
        super.onDragEnd(pTopic, pDraggable);
        this._spine.hitArea = null!;

        // console.log(pDraggable.data);
        this.updateDebugText();
    }

    protected onDraggableSelected(pTopic: string, pDraggable: MusicGameLoopButton): void {
        super.onDraggableSelected(pTopic, pDraggable);
        if (this.interactive) {
            const myLoop = this._data.loop;
            const loopToPlay = pDraggable.data.id;

            if (loopToPlay !== Constants.NO_LOOP || myLoop !== Constants.NO_LOOP) {
                if (loopToPlay === Constants.NO_LOOP) {
                    if (loopToPlay === Constants.NO_LOOP) {
                        if (this.isPreparing) {
                            this._debugText.text = "Click Here\nstop playing\ncancel queued";
                        }
                        else {
                            this._debugText.text = "Click Here\nstop playing";
                        }
                    }
                }
                else if (myLoop !== Constants.NO_LOOP) {
                    if (myLoop !== loopToPlay) {
                        this._debugText.text = "Click Here\nchange loops";
                    }
                    else {
                        this._debugText.text = "Click Here\nrestart loop";
                    }
                }
                else {
                    this._debugText.text = "Click Here\nstart playing";
                }
            }
            else if (this.isPreparing) {
                this._debugText.text = "Click Here\ncancel queued";
            }
            else {
                this.interactive = false;
            }
        }
    }

    protected onDraggableDeselected(pTopic: string, pDraggable: MusicGameLoopButton): void {
        super.onDraggableDeselected(pTopic, pDraggable);
        if (!this.interactive) {
            this.updateDebugText();
        }
    }

    protected onPause(pTopic: string): void {
        if(this._loadedSongName !== "") {
            console.log("paused " + this._loadedSongName);
        }
        Application.instance.audio.pause(this._loadedSongName, Constants.AUDIO_CATEGORY_SOLO);
    }

    protected onResume(pTopic: string): void {
        const track = Application.instance.audio.getAudioTrack(this._loadedSongName, Constants.AUDIO_CATEGORY_SOLO);

        if (track !== undefined) {
            if (track.getTimePos() > 0) {
                track.play();
                console.log("unpaused " + this._loadedSongName);
            }
        }

    }

    protected onSoloEnded() {
        const myLoop = this._data.loop;
        if (myLoop === Constants.NO_LOOP) return;
        const track = Application.instance.audio.getAudioTrack(this._loadedSongName, Constants.AUDIO_CATEGORY_SOLO);
        // PubSub.publishSync(Topics.SOLO_ENDED, {
        //     character: this.data.id,
        //     loop: myLoop,
        // });
        if (track?.isLooped()) {
            console.log(`solo ${this._loadedSongName} repeated`);
            track.setTimePos(0);
            // console.log("solo repeated ", { 'character': this.data.id, 'loop': myLoop});
        }
        else {
            // console.log("solo ended ", { 'character': this.data.id, 'loop': myLoop });
            this._data.loop = Constants.NO_LOOP;
            this._debugText.text = this.data.name;
            this.darken = 0.7;
            this.playAnimation(this.animations.idle);
        }
    }

    protected onMessageReceived(pTopic: string, pData: any) {
        switch (pTopic) {
            case Topics.SOLO_QUEUED:
                if (pData.character === this.data.id) {
                    this.onSoloQueued(pData);
                }
                break;
            case Topics.START_SOLO:
                if (pData.character === this.data.id) {
                    this.startSolo(pData);
                }
                break;
            case Topics.STOP_SOLO:
                if (pData.character === this.data.id) {
                    this.stopSolo(pData);
                }
                break;
            case Topics.STOP_ALL_SOLOS:
                this.stopSolo(pData);
                break;
        }
    }

    protected onSoloQueued(pData: any) {
        console.log("solo queued " + this._data.name);
        this.darken = 0;
        this.setProgressBarValues(pData.progressBarMinimum, pData.progressBarMaximum);
        this._progressBar.show(true);
        this.updateDebugText();
        if (!this.isPlaying) {
            this.playAnimation(this.animations.idleToReady, false);
        }
    }

    protected updateDebugText() {
        if (this.isPreparing) {
            if (this.data.loop !== Constants.NO_LOOP) {
                this._debugText.text = this.data.name + "\n" + "playing" + "\n" + "solo queued";
            }
            else {
                this._debugText.text = this.data.name + "\n" + "preparing";
            }
        }
        else if (this.data.loop !== Constants.NO_LOOP) {
            this._debugText.text = this.data.name + "\n" + "playing";
        }
        else {
            this._debugText.text = this.data.name + "\n" + "idle";
        }
    }

    protected playAnimation(pName: string, pLoop: boolean = true) {
        if (this._spine.state.hasAnimation(pName + "-stepped")) {
            console.log(this._data.name + " " + pName + "-stepped");
            const current = this._spine.state.getCurrent(0);
            if (current !== null && current.animation.name === pName + "-stepped") {
                if (pLoop === current.loop) {
                    // skip because we're already playing this animation
                    return;
                }
            }

            this._spine.state.setAnimation(0, pName + "-stepped", pLoop);
        }
        else if (this._spine.state.hasAnimation(pName)) {
            console.log(this._data.name + " " + pName);
            const current = this._spine.state.getCurrent(0);
            if (current !== null && current.animation.name === pName) {
                if (pLoop === current.loop) {
                    // skip because we're already playing this animation
                    return;
                }
            }

            this._spine.state.setAnimation(0, pName, pLoop);
        }
        else {
            console.error(this._data.name + " cannot find animation " + pName+ " or " + pName + "-stepped");
            // this._spine.state.setEmptyAnimation(0, 0);
        }
    }

    private onAnimComplete(pTrack: PIXI.spine.core.TrackEntry): void {
        if (pTrack.trackIndex === 0) {
            switch (pTrack.animation.name) {
                case this.animations.idleToReady:
                    this.playAnimation(this.animations.ready);
                    break;
            }
        }
    }
    /*
         private preloadSolo(pCulture: number, pAlternate: boolean, pPriority: number = 0): void {
            AudioPreloadManager.Enqueue({
                alternate: pAlternate,
                character: this.data.id,
                culture: pCulture,
                priority: pPriority,
            });
        } */

}